"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var soundtouch_js_1 = require("soundtouch-js");
/**
 * Offers some audio processing functions such as time stretching.
 */
var TimeStretcher = /** @class */ (function () {
    function TimeStretcher(audioContext, fadeLength) {
        this.audioContext = audioContext;
        this.fadeLength = fadeLength;
        this.BUFFER_SIZE = 1024;
        this.TIMESTRETCH_BUFFER_ZONE = 0.3; //seconds
    }
    TimeStretcher.prototype.getStretchedTrimmedBuffer = function (buffer, stretchRatio, offset, duration) {
        //trim if buffer too long
        if ((offset && offset != 0) || (duration && duration < buffer.duration)) {
            if (stretchRatio != 1) {
                //get too much cause of shitty timestretch algorithm
                duration += this.TIMESTRETCH_BUFFER_ZONE;
            }
            else {
                //add time for fade after source officially done
                duration += this.fadeLength;
            }
            buffer = this.getSubBuffer(buffer, this.toSamples(offset, buffer), this.toSamples(duration, buffer));
        }
        return this.getStretchedBuffer(buffer, duration, stretchRatio);
    };
    TimeStretcher.prototype.getStretchedBuffer = function (buffer, duration, stretchRatio) {
        if (stretchRatio && stretchRatio != 1) {
            buffer = this.soundTouchTimeStretch(buffer, stretchRatio);
            if (duration) {
                //trim it down again
                var shouldBeDuration = duration / stretchRatio;
                //add time for fade after source officially done
                buffer = this.getSubBuffer(buffer, 0, this.toSamples(shouldBeDuration + this.fadeLength, buffer));
            }
        }
        return buffer;
    };
    TimeStretcher.prototype.getSubBuffer = function (buffer, fromSample, durationInSamples) {
        //console.log(buffer, buffer.numberOfChannels, buffer.length, fromSample, durationInSamples, buffer.sampleRate)
        var samplesToCopy = Math.min(buffer.length - fromSample, durationInSamples);
        var subBuffer = this.audioContext.createBuffer(buffer.numberOfChannels, samplesToCopy, buffer.sampleRate);
        for (var i = 0; i < buffer.numberOfChannels; i++) {
            var currentCopyChannel = subBuffer.getChannelData(i);
            var currentOriginalChannel = buffer.getChannelData(i);
            for (var j = 0; j < samplesToCopy; j++) {
                currentCopyChannel[j] = currentOriginalChannel[fromSample + j];
            }
        }
        return subBuffer;
    };
    TimeStretcher.prototype.soundTouchTimeStretch = function (buffer, ratio) {
        var soundTouch = new soundtouch_js_1.SoundTouch(buffer.sampleRate);
        soundTouch.tempo = ratio;
        var source = this.createSource(buffer);
        var filter = new soundtouch_js_1.SimpleFilter(source, soundTouch);
        var result = this.audioContext.createBuffer(buffer.numberOfChannels, buffer.length * (1 / ratio), buffer.sampleRate);
        this.calculateStretched(buffer, result, filter);
        return result;
    };
    TimeStretcher.prototype.createSource = function (buffer) {
        return {
            extract: function (target, numFrames, position) {
                var channels = [];
                for (var i = 0; i < buffer.numberOfChannels; i++) {
                    channels.push(buffer.getChannelData(i));
                }
                for (var i = 0; i < numFrames; i++) {
                    for (var j = 0; j < channels.length; j++) {
                        target[i * channels.length + (j % channels.length)] = channels[j][i + position];
                    }
                }
                return Math.min(numFrames, channels[0].length - position);
            }
        };
    };
    TimeStretcher.prototype.calculateStretched = function (buffer, target, filter) {
        var channels = [];
        for (var i = 0; i < buffer.numberOfChannels; i++) {
            channels.push(target.getChannelData(i));
        }
        var samples = new Float32Array(this.BUFFER_SIZE * 2);
        var framesExtracted = filter.extract(samples, this.BUFFER_SIZE);
        var totalFramesExtracted = 0;
        while (framesExtracted) {
            for (var i = 0; i < framesExtracted; i++) {
                for (var j = 0; j < channels.length; j++) {
                    channels[j][i + totalFramesExtracted] = samples[i * channels.length + (j % channels.length)];
                }
            }
            totalFramesExtracted += framesExtracted;
            framesExtracted = filter.extract(samples, this.BUFFER_SIZE);
        }
        return channels;
    };
    TimeStretcher.prototype.toSamples = function (seconds, buffer) {
        if (seconds || seconds == 0) {
            return Math.round(seconds * buffer.sampleRate);
        }
    };
    return TimeStretcher;
}());
exports.TimeStretcher = TimeStretcher;



//////////////////
// WEBPACK FOOTER
// ./~/schedulo/lib/timestretcher.js
// module id = 2052
// module chunks = 3